import React from 'react';
import GetState from '../../GetState';
import { QuestRoute } from '../../api/QuestRoutes';
import Form from '../../forms/Form';
import Checkbox from '../../forms/Checkbox';
import Radio from '../../forms/Radio';
import Input from '../../forms/Input';
import Preput from '../../forms/Preput';
import { formatCurrency, generateId, statusColors } from '../../utility/functions';
import Icon from '../../forms/Icon';
import Button from '../../forms/Button';
import Table from '../../table/Table';
import HamQuest from '../../api/HamQuestGiver';
import AutoSelectAndUpgrade from '../../forms/formComponents/AutoSelectAndUpgrade';
import LocationSelectors from '../../forms/formComponents/LocationSelectors';
import ImageIndex from '../../forms/formComponents/ImageIndex';
import ColorInput from '../../forms/formComponents/ColorInput';
import TerminalIDsSelector from '../../forms/formComponents/TerminalIDsSelector';
import { userRoles } from '../../RoleProtected';
import ManagementRow from '../../table/ManagementRow';
import Select from '../../forms/Select';
import { HSOptions } from '../../../constants/HSOptions';
import ModalFactory from '../../Modal';

const Management = ({ userData, ...props }) => {

    const [details] = GetState(QuestRoute.washClubs.detail)
    const [washClubs, refreshWC] = GetState(QuestRoute.washClubs.clubs)

    const deleteWashClub = (club) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to delete ${club.productName}?`,
                type: 'warning',
            },
            promise: {
                title: 'Deleting Wash Club',
                body: `Deleting ${club.productName}`,
                callback: () => HamQuest.delete(QuestRoute.washClubs.edit(club.productId))
            },
            confirmed: {
                title: 'Success',
                body: `${club.productName} successfully deleted.`,
                type: 'success'
            },
            finally: () => refreshWC()
        })
    }

    const WCForm = ({ values, ...props }) => {
        if (values.setMaxUses === undefined) {
            values.setMaxUses = values.maxUses ? true : false;
        }
        // console.log(values)
        return (
            <>
                <Checkbox
                    label='Active'
                    name='active'
                />
                {/* 
                REMOVED FOR DEMO
                <Select
                    label='Type'
                    name='type'
                    options={HSOptions.washClub.type}
                    required
                /> 
                */}
                <Radio
                    label='Item'
                    name='itemId'
                    options={details.washes}
                    required
                />
                <Checkbox
                    label='Use Item Name'
                    name='productUseItemName'
                />
                <Input
                    label='Name'
                    name='productName'
                    disable={values.productUseItemName}
                    required={!values.productUseItemName}
                />
                <Checkbox
                    label='Use Product Details'
                    name='productUseItemDetail'
                />
                <Preput
                    label='Details'
                    name='details'
                    disabled={values.productUseItemDetail}
                />
                <Input
                    label='Sign-up Price'
                    name='signupPrice'
                    type='price'
                    required={values.type !== '5'}
                />
                <Input
                    label={values.type === '5' ? 'Price Per Wash' : 'Monthly Price'}
                    name='monthlyPrice'
                    type='price'
                    required
                />

                {values.type !== '5' && (
                    <Input
                        label='Additional Car Price'
                        name='additionalCarPrice'
                        type='price'
                        placeholder={values.monthlyPrice}
                    />
                )}

                <Checkbox
                    label='Is taxed'
                    name='taxable'
                />

                <Checkbox
                    label='Set Max Uses'
                    name='setMaxUses'
                />

                <Input
                    label='Max Uses'
                    name='maxUses'
                    type='number'
                    disabled={!values.setMaxUses}
                    required={values.setMaxUses}
                />
                <Input
                    label='Timer Max Uses'
                    name='timerMaxUses'
                    type='number'
                    disable={!values.setMaxUses}
                    required={values.setMaxUses}
                />

                {/*
                REMOVED FOR DEMO
                <Input
                    label='Wash Club Time (m)'
                    name='washClubTime'
                    type='number'
                />
                */}

                <b>Allowed Models</b>
                {details.kioskSubtypes?.map((e, i) => (
                    <Checkbox
                        key={'kioskSubtypes' + i}
                        name='kioskSubTypeIds'

                        label={e.label}
                        value={e.value}
                    />
                ))}

                <ImageIndex />

                <ColorInput />


                <AutoSelectAndUpgrade />

                <Input
                    label='SKU'
                    name='sku'
                />

                {/* <Checkbox
                    label='Using RFID Tags?'
                    name='isFulfillable'
                /> */}

                <LocationSelectors />

                <TerminalIDsSelector />
            </>
        )
    }

    const editWashClub = (club) => {
        club.washClubTime = Math.floor(club.washClubTime / 60);
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Edit ${club.productName}`,
            body: (
                <Form
                    name='washClubSettings'
                    inputs={{ ...club }}
                    onSubmit={e => {
                        e.washClubTime = e.washClubTime * 60;
                        return HamQuest.put(QuestRoute.washClubs.edit(club.productId), { ...e })
                            .then(() => {
                                refreshWC();
                                ModalFactory.close(id);
                            })
                    }}
                    text='Update'
                >
                    {({ values }) => <WCForm values={values} />}
                </Form>
            )
        })
    }

    const addWashClub = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Add Wash Club`,
            body: (
                <Form
                    name='washClubSettings'
                    inputs={{
                        active: false,
                        itemId: '',
                        productUseItemName: false,
                        productName: '',
                        productUseItemDetail: false,
                        details: '',
                        signupPrice: '',
                        monthlyPrice: '',
                        additionalCarPrice: '',
                        taxable: false,
                        setMaxUses: false,
                        maxUses: '',
                        timerMaxUses: '',
                        washClubTime: '',
                        logoImageIndex: '',
                        logoColor: '',
                        allowUpgrades: '',
                        autoSelect: '',
                        kioskSubTypeIds: [],
                        locations: [],
                        terminalIds: [],
                    }}
                    onSubmit={e => {
                        e.washClubTime = e.washClubTime * 60;
                        return HamQuest.post(QuestRoute.washClubs.clubs, { ...e })
                            .then(() => {
                                refreshWC();
                                ModalFactory.close(id);
                            })
                    }}
                    text='Add'
                >
                    {({ values }) => <WCForm values={values} />}
                </Form>
            )
        })
    }

    const tableConfig = {
        data: washClubs,
        controls: [<Button roles={userRoles.editProducts} onClick={addWashClub}>Add Wash Club</Button>],
        // disableHeaderSearch: true,
        colSpacing: [20, 15],
        headers: [
            {
                label: 'Name',
                propKey: 'productName',
            }, {
                label: 'Kiosk Item',
                propKey: 'kioskItemName',
                options: true
            }, {
                label: 'Signup Price',
                propKey: 'signupPrice',
                type: 'number'
            }, {
                label: 'Monthly Price',
                propKey: 'monthlyPrice',
                type: 'number'
            }, {
                label: 'Add. Car Price',
                propKey: 'additionalCarPrice',
                type: 'number'
            }, {
                label: 'Active',
                propKey: 'active',
                options: true,
            }, {
                label: 'Max Uses',
                propKey: 'maxUses',
                type: 'number'
            }, {
                label: 'Timer Max Uses',
                propKey: 'timerMaxUses',
                type: 'number'
            },
        ],
        quickSort: [
            {
                label: 'Active Clubs',
                propKey: 'active',
                query: 'true',
                color: '#21D59B',
                defaultSearch: true
            },
        ],
        renderFormat: (e) => (
            <ManagementRow
                key={generateId()}
                controls={[
                    <Button roles={userRoles.editProducts} key={generateId()} onClick={() => editWashClub(e)}>Edit</Button>,
                    <Button roles={userRoles.editProducts} key={generateId()} onClick={() => deleteWashClub(e)}>Delete</Button>
                ]}
            >
                <td>{e.productName}</td>
                <td>{e.kioskItemName}</td>
                <td>{formatCurrency(e.signupPrice)}</td>
                <td>{formatCurrency(e.monthlyPrice)}</td>
                <td>{e.additionalCarPrice ? formatCurrency(e.additionalCarPrice) : '-'}</td>
                <td><Icon icon={e.active ? 'check' : 'cross'} style={{ color: e.active ? statusColors.Active : statusColors.NotValidated }} /></td>
                <td>{e.maxUses || '-'}</td>
                <td>{e.timerMaxUses || '-'}</td>
            </ManagementRow>
        )
    }

    return (
        <Table config={tableConfig} />
    );
}

export default Management;
